import React, { useState, useEffect } from "react"
import { isEmpty } from "lodash"
import "./_style.scss"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import { FreeMode, Pagination } from "swiper"
import "swiper/css/free-mode"

// Atoms
import RulerTitle from "§/src/components/atoms/title/ruler-title"
import TileButtonContent from "./tile-button-content"

import SibarModal from "../sibar-modal"

// Language
import { useTranslation } from "react-i18next"

const Resources = props => {
  const { t } = useTranslation()

  const resources = props.resources || []
  const domainUrl = props.domainUrl

  const resourcesPretitle = t("Download")
  const resourcesTitle = t("Risorse disponibili")
  const modalid = "modal-" + Math.floor(Math.random() * 99999)
  const [clickedResources, setClickedResources] = React.useState({})

  // set component class
  const compClassName = ""
  var compClass =
    props.className != undefined
      ? compClassName + " " + props.className
      : compClassName

  const sliderId = "resorces-sw"

  const getLabel = resource => {
    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]
    return (
      resource.category[lang] ||
      resource.category["en"] ||
      resource.category["all"]
    )
  }

  return !isEmpty(resources) ? (
    <div comp="resources" className={compClassName}>
      <SibarModal
        modalid={modalid}
        resources={resources}
        current={clickedResources}
        domainUrl={domainUrl}
      />
      <RulerTitle pretitle={resourcesPretitle} title={resourcesTitle} />
      <Swiper
        // autoplay={{
        // 	delay: 5000,
        // 	disableOnInteraction: true,
        // }}
        slidesPerView={1.5}
        spaceBetween={20}
        freeMode={true}
        loop={false}
        breakpoints={{
          576: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 2.75,
          },
          992: {
            slidesPerView: 4,
          },
        }}
        pagination={{
          el: "#" + sliderId + "-pagination",
          type: "progressbar",
        }}
        modules={[FreeMode, Pagination]}
        className="products-swiper"
        id={sliderId}
      >
        {resources.map((resource, i) => (
          <SwiperSlide key={i}>
            <TileButtonContent
              data={{
                cta: ["", "", "", "#"],
                template: "blue",
                buttonTemplate: "lg-right",
                title: t(getLabel(resource)),
              }}
              className=""
              modalid={modalid}
              onClick={() => setClickedResources(resource)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        id={sliderId + "-pagination"}
        className="gefran-swiper-pagination-progressbar position-relative mt-4 mt-md-5"
      ></div>
    </div>
  ) : (
    ""
  )
}

export default Resources
